/* Установщик «Танец»: объект в window на том месте порядка скриптов, где стоял assets/bot-dance.js.
   В серверном режиме движок шаблона получает сервер экрана (dance-server.ts) и экран dance (пресеты dance и swap) встаёт в реестр движков
   студии; выбирает его только список экранов сборки (engine-kit/engine-default.json — пустой до коммита переключения, инвариант I4). */
import { isServerMode } from '../../platform/server-mode';
import { createDance } from './engine';
import { createDanceServer, registerDanceEngine } from './dance-server';

export function installDance() {
  const server = isServerMode();
  createDance(server ? createDanceServer : null);
  if (server) registerDanceEngine();
}
